import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    getTransactions as fetchTransactions,
    fetchUrl
} from './transactionsActions';
import {
    getCount,
    getPages,
    getTransactions,
    getIsTransactionsLoading,
    getTransactionsErrorMessage,
    getHasMore
} from './transactionsEntity';
import { getShouldDoLargeExport, getCsvData } from '../CSVs/csvEntity';
import { getIsCaptureSuccessfulById } from '../Capture/captureEntity';
import { getIsVoidSuccessfulById } from '../Void/voidEntity';
import { getIsRefundSuccessfulById } from '../Refund/refundEntity';
import { selectTransaction } from './transactionsActions';
import { startLargeExport } from '../Exports/exportsActions';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
    cardTypesMapper,
    doesPropExistAndHasItChanged,
    processMethodMapper,
    transactionStatusMapper,
    transactionTypeMapper,
    transactionStatus,
    getCurrencyCode,
    dataTransform
} from '@nexio/emvio-util-app';
import TransactionsListItem from './TransactionsListItem/TransactionsListItem';
import { toggleModal } from '../Modal/modalActions';
import ColorDollarAmountCell from '../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import AmountFilter from '../Table/Filters/AmountFilter/AmountFilter';
import FraudFilter from '../Table/Filters/FraudFilter/FraudFilter';
import {
    transformDateCell
} from '../../utils/cell';
import FilterWithMapper from '../Table/Filters/FilterWithMapper/FilterWithMapper';
import Table from '../Table/Table';
import { getTransaction } from '../Transaction/transactionActions';
import CurrencyCodeFilter from '../Table/Filters/CurrencyCodeFilter/CurrencyCodeFilter';
import SmartCurrencyCodeFilter from '../Table/Filters/CurrencyCodeFilter/SmartCurrencyCodeFilter';
import { getSelectedMerchantIdsString } from '../MerchantSelector/merchantSelectorViewState';
import { getColumnsByUniqueTableName } from '../Table/tableEntity';
import { getMerchantsMapper } from '../Merchants/merchantsEntity';
import { getMerchants } from '../Merchants/merchantsActions';
import { getTimezone } from '../UserSettings/userSettingsEntity';
import { prettifyDate } from '../../utils/string';
import { getSortedGatewayAndApmMapperArray, localGatewayAndApmMapper } from '../../utils/gateways';
import { getGateways } from '../Gateways/gatewaysEntity';
import { getApms } from '../Apms/apmEntity';
import InPageMerchantSelector from '../MerchantSelector/InPageMerchantSelector';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { getSelf } from '../Self/selfEntity';

export function setOverrideMessageBasedOnStatus(transaction) {
    const amount = _.get(transaction, 'amount');
    const status = _.get(transaction, 'transactionStatus');

    if (_.isNull(amount) && status === transactionStatus.settled) {
        return 'Unavailable';
    }

    return 'Pending...';
}

const toolTipContent = <div>Tip: Begin search with ... to search<br />the last four. Example: ...1234</div>;

export class Transactions extends Component {
    dateKey = 'transactionDate';

    state = {
        isExportMessageVisible: false,
        exportType: 'csv'
    };

    static propTypes = {
        isRefundSuccessful: PropTypes.bool,
        isVoidSuccessful: PropTypes.bool,
        onRefundTransaction: PropTypes.func,
        onVoidTransaction: PropTypes.func,
        getMerchants: PropTypes.func,
        selectedMerchantIds: PropTypes.string,
        columns: PropTypes.array,
        merchantMap: PropTypes.any,
        kickOffLargeExport: PropTypes.func,
        shouldDoLargeExport: PropTypes.bool,
        csvData: PropTypes.any,
        timezone: PropTypes.string,
        gateways: PropTypes.any,
        apms: PropTypes.any,
        self: PropTypes.any
    };
    constructor(props) {
        super(props);
        this.defaultColumnsAndProps = [
            {
                accessor: 'merchantName',
                className: ['cursor-pointer'],
                filterable: false,
                label: 'Merchant',
                minWidth: 150,
                show: true,
                sortable: false
            },
            {
                accessor: 'transactionDate',
                Cell: transformDateCell,
                className: ['cursor-pointer'],
                defaultSortDesc: true,
                filterable: false,
                label: 'Date',
                minWidth: 100,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'transactionDate $AS timezone',
                Cell: (transactionDate) => prettifyDate(transactionDate, { dateTimeFormatOutput: 'z' }),
                className: ['cursor-pointer'],
                defaultSortDesc: false,
                filterable: false,
                label: 'Timezone',
                minWidth: 100,
                show: false,
                transformData: dataTransform.dateGetTimezone,
                transformType: 'dateGetTimezone',
                sortable: false
            },
            {
                accessor: 'gateway.batchRef',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Gateway Batch ID',
                minWidth: 170,
                show: true
            },
            {
                accessor: 'processor.batchRef',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Processor Batch ID',
                minWidth: 185,
                show: true
            },
            {
                accessor: 'achDetailId',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Deposit Detail ID',
                minWidth: 165,
                show: true
            },
            {
                accessor: 'id',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Nexio Transaction ID',
                minWidth: 180,
                show: true,
                sortable: false
            },
            {
                accessor: 'processMethod',
                transformData: dataTransform.processMethodMapper,
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<FilterWithMapper filter={filter} mapper={processMethodMapper} onChange={onChange} />),
                label: 'Method',
                minWidth: 160,
                show: true,
                transformType: 'processMethodMapper'
            },
            {
                accessor: 'cardType',
                transformData: dataTransform.cardTypesMapper,
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<FilterWithMapper filter={filter} mapper={cardTypesMapper} onChange={onChange} />),
                label: 'Card Type',
                minWidth: 120,
                show: true,
                transformType: 'cardTypesMapper'
            },
            {
                accessor: 'cardHolder',
                transformData: dataTransform.uppercase,
                className: ['cursor-pointer'],
                label: 'Card Holder',
                minWidth: 140,
                show: false,
                transformType: 'uppercase'
            },
            {
                accessor: 'cardNumber',
                transformData: dataTransform.ellipsisNumber,
                className: ['cursor-pointer'],
                label: 'Card Num',
                title: toolTipContent,
                minWidth: 140,
                show: true,
                transformType: 'ellipsisNumber'
            },
            {
                accessor: 'amount',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} currencyCode={getCurrencyCode(props.original.currencyId)} overrideText={setOverrideMessageBasedOnStatus(props.original)} />,
                className: ['right-justify', 'cursor-pointer'],
                Filter: ({ filter, onChange }) => (<AmountFilter filter={filter} onChange={onChange} />),
                label: 'Amount',
                minWidth: 120,
                show: true
            },
            {
                accessor: 'transactionDetails.surcharge',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} currencyCode={getCurrencyCode(props.original.currencyId)} overrideText=" " />,
                className: ['right-justify', 'cursor-pointer'],
                Filter: ({ filter, onChange }) => (<AmountFilter filter={filter} onChange={onChange} />),
                label: 'Surcharge',
                minWidth: 130,
                show: false
            },
            {
                accessor: 'settledDate',
                Cell: transformDateCell,
                className: ['cursor-pointer'],
                filterable: false,
                label: 'Settled Date',
                minWidth: 150,
                show: true,
                transformData: dataTransform.dateTimezoneButHideTimezone,
                transformType: 'dateTimezoneButHideTimezone'
            },
            {
                accessor: 'transactionType',
                transformData: dataTransform.transactionTypeMapper,
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<FilterWithMapper filter={filter} mapper={transactionTypeMapper} onChange={onChange} />),
                label: 'Type',
                minWidth: 105,
                show: true,
                transformType: 'transactionTypeMapper'
            },
            {
                accessor: 'currencyId',
                transformData: dataTransform.currencyCode,
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<CurrencyCodeFilter filter={filter} onChange={onChange} />),
                label: 'Currency',
                minWidth: 120,
                show: false,
                transformType: 'currencyCode'
            },
            {
                accessor: 'foreignProcessingCurrency.amount',
                Cell: (props) => <ColorDollarAmountCell amount={props.value} currencyCode={getCurrencyCode(_.get(props, 'original.foreignProcessingCurrency.currencyId'))} overrideText=" " />,
                className: ['right-justify', 'cursor-pointer'],
                Filter: ({ filter, onChange }) => (<AmountFilter filter={filter} onChange={onChange} />),
                label: 'Foreign Amount',
                minWidth: 160,
                show: false
            },
            {
                accessor: 'foreignProcessingCurrency.currencyId',
                transformData: dataTransform.currencyCodeNoDefault,
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<SmartCurrencyCodeFilter filter={filter} onChange={onChange} />),
                label: 'Foreign Currency',
                minWidth: 180,
                show: false,
                transformType: 'currencyCode'
            },
            {
                accessor: 'transactionStatus',
                transformData: dataTransform.transactionStatusMapper,
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<FilterWithMapper filter={filter} mapper={transactionStatusMapper} onChange={onChange} />),
                label: 'Status',
                minWidth: 110,
                show: true,
                transformType: 'transactionStatusMapper'
            },
            {
                accessor: 'authCode',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Auth Code',
                minWidth: 120,
                show: true
            },
            {
                accessor: 'plugin.orderNumber',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Order ID',
                minWidth: 110,
                show: true
            },
            {
                accessor: 'gateway.refNumber',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Ref Num',
                minWidth: 110,
                show: false
            },
            {
                accessor: 'plugin.originalId',
                className: ['cursor-pointer'],
                label: 'Payment ID',
                minWidth: 130,
                show: false
            },
            {
                accessor: 'plugin.invoice',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Invoice',
                minWidth: 105,
                show: false
            },
            {
                accessor: 'plugin.description',
                className: ['cursor-pointer'],
                label: 'Description',
                minWidth: 140,
                show: false
            },
            {
                accessor: 'customer.customerRef',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Customer ID',
                minWidth: 150,
                show: false
            },
            {
                accessor: 'gateway.gatewayType',
                transformData: (data) => _.get(localGatewayAndApmMapper(this.props.gateways, this.props.apms), data.value, '').toUpperCase(),
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<FilterWithMapper filter={filter} mapper={getSortedGatewayAndApmMapperArray(this.props.gateways, this.props.apms)} onChange={onChange} />),
                label: 'Gateway',
                minWidth: 110,
                show: false,
                transformType: 'gatewayMapper'
            },
            {
                accessor: 'gateway.message',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Gateway Message',
                minWidth: 170,
                show: true
            },
            {
                accessor: 'kount.status',
                transformData: dataTransform.fraudMapper,
                className: ['cursor-pointer'],
                Filter: ({ filter, onChange }) => (<FraudFilter filter={filter} onChange={onChange} />),
                label: 'Fraud Status',
                minWidth: 140,
                show: false,
                transformType: 'fraudMapper'
            },
            {
                accessor: 'merchantId',
                className: ['cursor-pointer'],
                excelStringField: true,
                filterable: false,
                label: 'Merchant ID',
                minWidth: 145,
                show: false
            },
            {
                accessor: 'bankTransfer.routing',
                className: ['cursor-pointer'],
                excelStringField: true,
                filterable: false,
                label: 'Routing Number',
                minWidth: 175,
                show: false
            },
            {
                accessor: 'bankTransfer.account',
                className: ['cursor-pointer'],
                excelStringField: true,
                filterable: false,
                label: 'Account Number',
                minWidth: 175,
                show: false
            },
            {
                accessor: 'subscription.subscriptionRef',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Subscription ID',
                minWidth: 175,
                show: false
            },
            {
                accessor: 'customer.email',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'Customer Email',
                minWidth: 175,
                show: false,
                sortable: false,
                filterable: true
            },
            {
                accessor: 'transactionDetails.userName',
                className: ['cursor-pointer'],
                excelStringField: true,
                label: 'User',
                minWidth: 175,
                show: false,
                sortable: false,
                filterable: true
            }
        ];
    }

    componentDidUpdate(previousProps) {
        if (doesPropExistAndHasItChanged(previousProps, this.props, 'isRefundSuccessful')
            || doesPropExistAndHasItChanged(previousProps, this.props, 'isVoidSuccessful')
            || doesPropExistAndHasItChanged(previousProps, this.props, 'isCaptureSuccessful')) {
            this.setState({ needsRefetch: true });
        }

        if (doesPropExistAndHasItChanged(previousProps, this.props, 'shouldDoLargeExport') && this.props.shouldDoLargeExport === true) {
            const { selectedMerchantIds, columns, merchantMap } = this.props;
            const { filters, sorts } = this.state;
            this.setState({
                isExportMessageVisible: true,
                exportButtonMessage: 'The data range is too large to export now. We will send you an email with a link to the finished report.'
            });

            this.props.kickOffLargeExport(selectedMerchantIds, columns, filters, sorts, this.dateKey, 'transaction', merchantMap, this.props.timezone, this.state.exportType);
        }
    }

    toggleExportMessageVisible = (e) => {
        e.stopPropagation();
        this.setState((prevState) => ({
            isExportMessageVisible: !prevState.isExportMessageVisible
        }));
    };

    getTableState = (tableState) => {
        this.setState({
            ...tableState
        });
    };

    setExportType = (type) => {
        this.setState({ exportType: type });
    };

    render() {
        return (
            <>
                {this.props.flags?.resellerPhase1 && this.props.self?.accountType === 'RESELLER' && <InPageMerchantSelector />}
                <Table
                    className="emvio-transactions-table"
                    columnsToNotClick={['Action']}
                    countSelector={getCount}
                    dateKey={this.dateKey}
                    dataSelector={getTransactions}
                    defaultColumnsAndProps={this.defaultColumnsAndProps}
                    defaultSorted={[{
                        desc: true,
                        id: this.dateKey
                    }]}
                    errorMessageSelector={getTransactionsErrorMessage}
                    exportButtonMessage={this.state.exportButtonMessage}
                    fetchData={fetchTransactions}
                    fetchUrl={fetchUrl}
                    filterable={true}
                    getTableState={this.getTableState}
                    hasMoreSelector={getHasMore}
                    hasNoCount={true}
                    isDataLoadingSelector={getIsTransactionsLoading}
                    isExportMessageVisible={this.state.isExportMessageVisible}
                    itemKey="id"
                    ListItemComponent={TransactionsListItem}
                    noDataText="No Transactions Found"
                    pagesSelector={getPages}
                    selectRow={selectTransaction}
                    shouldUseGlobalDate
                    toggleExportMessageVisible={this.toggleExportMessageVisible}
                    uniqueTableName="Transactions"
                    timezone={this.props.timezone}
                    setExportType={this.setExportType}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    const transaction = getTransaction(state);
    const transactionId = _.get(transaction, 'id');

    return {
        isCaptureSuccessful: getIsCaptureSuccessfulById(state, transactionId),
        isRefundSuccessful: getIsRefundSuccessfulById(state, transactionId),
        isVoidSuccessful: getIsVoidSuccessfulById(state, transactionId),
        selectedMerchantIds: getSelectedMerchantIdsString(state),
        columns: getColumnsByUniqueTableName(state, 'Transactions'),
        shouldDoLargeExport: getShouldDoLargeExport(state),
        csvData: getCsvData(state),
        merchantMap: getMerchantsMapper(state),
        timezone: getTimezone(state),
        gateways: getGateways(state),
        apms: getApms(state),
        self: getSelf(state)
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onCaptureTransaction: (transaction) => dispatch(toggleModal('capture', transaction)),
        onRefundTransaction: (transaction) => dispatch(toggleModal('refund', transaction)),
        onVoidTransaction: (transaction) => dispatch(toggleModal('void', transaction)),
        getMerchants: () => dispatch(getMerchants()),
        kickOffLargeExport: (merchantIds, columns, filters, sorts, dateKey, table, merchantMap, timezone, exportType) => {
            dispatch(startLargeExport(merchantIds, columns, filters, sorts, dateKey, table, merchantMap, timezone, exportType));
        }
    };
}

// export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Transactions));
export default withLDConsumer()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Transactions)));
